import defaultTheme from './default.theme';
import { ThemeType } from 'types/CommonTypes';

const darkTheme: ThemeType = {
    ...defaultTheme,
};

export default darkTheme;
